import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatTabGroup, MatTabsModule } from '@angular/material/tabs';
import { BehaviorSubject } from 'rxjs';
import { FormMode } from 'src/app/controls/common/form-mode';
import { BatchRecord } from 'src/app/controls/inline-editable-table/models/BatchRecord';
import { EnumHelper } from 'src/app/helpers/enum-helper';
import { AttributeValue } from 'src/app/models/attribute-value';
import { PropertyType } from 'src/app/models/enums/property-type';
import { IAttribute } from 'src/app/models/interfaces/attribute.interface';
import { AttributeDetailContext } from '../attribute-detail-context';
import { AttributeFormComponent } from '../attribute-form/attribute-form.component';
import { AttributeValueFormComponent } from '../attribute-value-form/attribute-value-form.component';

@Component({
    selector: 'app-attribute-detail',
    templateUrl: './attribute-detail.component.html',
    styleUrls: ['./attribute-detail.component.scss'],
    imports: [MatTabsModule, AttributeFormComponent, AttributeValueFormComponent],
})
export class AttributeDetailComponent implements OnInit {
    /**
     * Mode d'affichage du formulaire (consultation / edition / création)
     */
    public FormMode = FormMode;
    public PropertyType: any = PropertyType;

    /**
     * Reference au composant groupe d'onglets.
     */
    @ViewChild(MatTabGroup)
    tabGroup: MatTabGroup;

    /**
     * Emis lorsque le formulaire est mis à jour (clic sur le bouton sauver)
     */
    @Output()
    public attributeUpdated: EventEmitter<IAttribute> = new EventEmitter();

    /**
     * Emis lorsque les valeurs sont mises à jour (clic sur le bouton sauver)
     */
    @Output()
    public attributeValuesUpdated: EventEmitter<BatchRecord<AttributeValue>> = new EventEmitter();

    /**
     * Emis lorsque des changements sur l'onglet valeurs necessite sont rechargement.
     */
    @Output()
    public needAttributeValuesRefreshed: EventEmitter<number> = new EventEmitter();

    /**
     * Emis lorsque le formulaire est annuler(clic sur le bouton annuler)
     */
    @Output()
    public canceled: EventEmitter<boolean> = new EventEmitter();

    /**
     * Indique si le composant est en mode debug (affiche des informations pour le developpeur)
     */
    public debugMode = false;

    /**
     * Contexte du formulaire.
     */
    public _context: AttributeDetailContext;

    /**
     * Utilisé pour propager des changements de contexte.
     */
    public _context$: BehaviorSubject<AttributeDetailContext> = new BehaviorSubject(null);

    /**
     * Appellé par le composant parent pour specifier un nouveau contexte.
     */
    @Input()
    set context(value: AttributeDetailContext) {
        // set the latest value for _data BehaviorSubject
        this._context$.next(value);
    }

    constructor(public enumHelper: EnumHelper) {}

    /**
     * Initialise le composant.
     */
    ngOnInit(): void {
        /**
         * S'abonne aux changements de contexte
         */
        this._context$.subscribe((x) => {
            this._context = x;
        });
    }

    /**
     * Appellé lorsque des changements sur le formulaire "infos" sont sauvegardés.
     * @param attribute: Infos de l'attribute modifié.
     */
    public onAttributeUpdated(attribute: IAttribute) {
        this.attributeUpdated.emit(attribute);
    }

    /**
     * Appellé lorsque des changements sur l'onglet valeurs sont sauvegardés.
     * @param attribute: Infos de l'attribute modifié.
     */
    public onattributeValuesUpdated(attributeValues: BatchRecord<AttributeValue>) {
        this.attributeValuesUpdated.emit(attributeValues);
    }

    /**
     * Appellé lorsque des changements sur l'onglet valeurs necessite sont rechargement.
     * @param attributeId: Id de l'attribut.
     */
    public onNeedAttributeValuesRefreshed(attributeId: number) {
        this.needAttributeValuesRefreshed.emit(attributeId);
    }
    /**
     * Appellé lorsque des changements sur le formulaire "infos" sont annulés.
     * @param user: Infos de l'article modifié.
     */
    public onCanceled(value: boolean) {
        this.canceled.emit(value);
    }
}
